/**
 * @todo It's a temporary solution; it should be removed after feature flags are fully implemented,
 * and OMB will be built into static JS instead of a working container.
 */

const envConfigs = {
  dev: {
    featureFlagsApiUrl:
      "https://status.mybenefit.g4n.eu/?action=getFeatureFlags&env=dv1",
    reportingTool: "https://reports.adm-kafeteria.dev.aws.mybenefit.pl",
    adminSelfUrl: "https://adm-kafeteria.dev.aws.mybenefit.pl",
    permissionsUrl: "https://api.dev.aws.mybenefit.pl",
    growthbookClientKey: "sdk-f9CAUhc7w8kNqh3Q",
    growthbookDevMode: true,
    payrollModuleUrl: "https://saas-api.wynagrodzenia.dev.aws.mybenefit.pl",
    mbDashboardUrl: "https://start.dev.aws.mybenefit.pl",
  },
  devFeatureBranch: {
    featureFlagsApiUrl:
      "https://status.mybenefit.g4n.eu/?action=getFeatureFlags&env=dv1",
    reportingTool: "https://reports.adm-kafeteria.dev.aws.mybenefit.pl",
    adminSelfUrl: "https://adm-kafeteria.dev.aws.mybenefit.pl",
    permissionsUrl: "https://api.dev.aws.mybenefit.pl",
    growthbookClientKey: "sdk-hoCN1Z3LuUlgU4",
    growthbookDevMode: true,
    payrollModuleUrl: "https://saas-api.wynagrodzenia.dev.aws.mybenefit.pl",
    mbDashboardUrl: "https://start.dev.aws.mybenefit.pl",
  },
  staging: {
    featureFlagsApiUrl:
      "https://status.mybenefit.g4n.eu/?action=getFeatureFlags&env=qa1",
    reportingTool: "https://reports.adm-kafeteria.staging.aws.mybenefit.pl",
    adminSelfUrl: "https://adm-kafeteria.staging.aws.mybenefit.pl",
    permissionsUrl: "https://api.staging.aws.mybenefit.pl",
    growthbookClientKey: "sdk-y91w4Kir57kNw8xW",
    growthbookDevMode: true,
    payrollModuleUrl: "https://saas-api.wynagrodzenia.staging.aws.mybenefit.pl",
    mbDashboardUrl: "https://start.staging.aws.mybenefit.pl",
  },
  stagingFeatureBranch: {
    featureFlagsApiUrl:
      "https://status.mybenefit.g4n.eu/?action=getFeatureFlags&env=qa1",
    reportingTool: "https://reports.adm-kafeteria.staging.aws.mybenefit.pl",
    adminSelfUrl: "https://adm-kafeteria.staging.aws.mybenefit.pl",
    permissionsUrl: "https://api.staging.aws.mybenefit.pl",
    growthbookClientKey: "sdk-Ee9X8Zpu5ALiMb0",
    growthbookDevMode: true,
    payrollModuleUrl: "https://saas-api.wynagrodzenia.staging.aws.mybenefit.pl",
    mbDashboardUrl: "https://start.staging.aws.mybenefit.pl",
  },
  prod: {
    featureFlagsApiUrl: "",
    reportingTool: "https://reports.adm-kafeteria.mybenefit.pl",
    adminSelfUrl: "https://adm-kafeteria.mybenefit.pl",
    permissionsUrl: "https://api.mybenefit.pl",
    growthbookClientKey: "sdk-W7RCnTwWfvBPFunN",
    growthbookDevMode: false,
    payrollModuleUrl: "https://saas-api.wynagrodzenia.mybenefit.pl",
    mbDashboardUrl: "https://start.mybenefit.pl",
  },
};

const getEnvironmentConfig = () => {
  // eslint-disable-next-line max-len
  const domainRegex = /https:\/\/((?<env>(dv1|qa1))|(?<adm>adm)|(?<branchStaging>[a-zA-Z0-9-]+\.adm-kafeteria\.staging\.aws)|(?<branchDev>[a-zA-Z0-9-]+\.adm))(?:-(?<dv>[0-9]*).omb.mybenefit.g4n.eu|\.staging\.aws\.mybenefit\.pl|\.dev\.aws\.mybenefit\.pl|-kafeteria(?<envAdm>\.dev\.aws|\.staging\.aws|)\.mybenefit\.pl)/g.exec(
      window.location.href
    );

  /**
   * Check if any of:
   *
   * https://adm-kafeteria.dev.aws.mybenefit.pl
   * https://dv1.dev.aws.mybenefit.pl/
   * https://dv1-<number>.omb.mybenefit.g4n.eu
   *
   * https://adm-kafeteria.staging.aws.mybenefit.pl
   * https://<branch-name>.adm-kafeteria.staging.aws.mybenefit.pl
   * https://qa1.staging.aws.mybenefit.pl
   * https://qa1-<number>.omb.mybenefit.g4n.eu
   *
   * https://adm-kafeteria.mybenefit.pl
   */

  if (domainRegex?.groups?.envAdm === ".dev.aws") {
    return envConfigs.dev;
  }
  if (domainRegex?.groups?.env === "dv1") {
    return envConfigs.devFeatureBranch;
  }
  if (domainRegex?.groups?.envAdm === ".staging.aws" || domainRegex?.groups?.branchStaging) {
    return envConfigs.staging;
  }

  if (domainRegex?.groups?.env === "qa1") {
    return envConfigs.stagingFeatureBranch;
  }

  if (domainRegex?.groups?.envAdm === "") {
    return envConfigs.prod;
  }

  // Default to dev config if no match
  return envConfigs.dev;
};

export default getEnvironmentConfig;
